import { createFileRoute } from "@tanstack/react-router";
import { OperatorHome } from "@/features/operator/OperatorHome";

export const Route = createFileRoute("/app/operator/")({ component: OperatorHome });
